export default __webpack_public_path__ + "static/Trader-ebd7758590faf644bc8be2582621b325.png";